'use client'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/shared/ui/dialog'
import { Button } from '@/shared/ui/button'
import { toast } from 'sonner'
import { useDeleteNotification } from '@/views/product-detail/hooks/use-delete-notification'
import { useNotificationStore } from '@/providers/notification-store-provider'

export interface NotificationCancelConfirmDialogProps {
  trigger?: React.ReactNode
}

export const NotificationCancelConfirmDialog = ({
  trigger,
}: NotificationCancelConfirmDialogProps) => {
  const { dialogOpen, onOpenDialogChange, notificationId, productId } =
    useNotificationStore((state) => state)
  const { mutate } = useDeleteNotification()

  const handleDelete = () => {
    if (!notificationId) {
      toast.error('새로고침 후 다시 시도해주세요.')
      return
    }
    mutate([{ notificationId, productId }], {
      onSuccess: () => {
        toast.success('알림이 해제되었습니다.')
      },
      onError: () => {
        toast.error('새로고침 후 다시 시도해주세요.')
      },
    })
  }

  return (
    <Dialog open={dialogOpen} onOpenChange={onOpenDialogChange}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">알림 해제</DialogTitle>
          <DialogDescription className="text-center">
            알림을 해제하시겠습니까?
          </DialogDescription>
          <div className="h-4" />
          <DialogFooter className="flex gap-1">
            <DialogClose asChild>
              <Button
                className="w-full"
                variant={'outline'}
                onClick={(e) => e.stopPropagation()}
              >
                취소
              </Button>
            </DialogClose>
            <DialogClose asChild>
              <Button
                onClick={(event) => {
                  event.stopPropagation()
                  handleDelete()
                }}
                className="w-full"
              >
                해제
              </Button>
            </DialogClose>
          </DialogFooter>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
